module.exports = __webpack_public_path__ + "img/bidsStopLoss.e66490cb.svg";